
import { mapMutations, mapState } from 'vuex';
import Testimonial from '@/components/blocks/testimonial.vue';
import Intermission from '@/components/intermission.vue';

export default {
  name: 'Testimonials',

  components: {
    Testimonial,
    Intermission,
  },

  async fetch() {
    try {
      const { data } = await this.$wp.testimonials();
      if (data.length) {
        this.setTestimonials(data);
      } else {
        return this.$nuxt.error({ statusCode: 404 });
      }
    } catch (_) {
      return this.$nuxt.error({ statusCode: 404 });
    }
  },

  computed: {
    ...mapState(['testimonials']),

    ...mapState({
      info: (state) => state.options.field_testimonials_start,
    }),

    testimonialIds() {
      return this.testimonials.map((t) => t.id);
    },
  },

  methods: {
    ...mapMutations(['setTestimonials']),
  },

  head() {
    return this.$seo.page('testimonials', this.$route.path);
  },
};
